import React from 'react';

function ManagesMessagePage() {
    return <div>ManagesMessagePage</div>;
}

export default ManagesMessagePage;
